import { DeviceRegistrationLocationState } from "./deviceRegistrationLocationState";
import { DiscoveryResult, SiteDetailsValues } from "./NewUserFlow/newUserFlowState";

/**
 * Minimal state `DeviceDiscoveryStep`/`CongratulationsStep` need — shared by
 * both the new-user (CM-618) and existing-user (CM-619) branches, which reach
 * a chosen site differently: new-user always creates one (`siteDetails`),
 * existing-user either picks one from a list (`siteId`+`siteName`) or also
 * creates one (`siteDetails`, alongside `siteId`/`siteName`).
 */
export interface DiscoveryFlowState extends DeviceRegistrationLocationState {
  customerId?: string;
  siteId?: string;
  siteName?: string;
  siteDetails?: SiteDetailsValues;
  deviceId?: string;
  discoveryResult?: DiscoveryResult;
}

export const hasSiteReady = (state: DiscoveryFlowState | undefined): state is DiscoveryFlowState =>
  !!state && (!!state.siteDetails || (!!state.siteId && !!state.siteName));

export const hasDiscoveryResult = (
  state: DiscoveryFlowState | undefined
): state is DiscoveryFlowState & { discoveryResult: DiscoveryResult } => !!state && !!state.discoveryResult;
